
import { sagas as sagasMap } from '../../map';

/**
 * Command `mapmultiscene.setMapCenterByMultiScene`
 *
 */
function setMapCenterByMultiScene(params, dispatch, store) {

    let mapMultiScene = store.getState().mapMultiScene.mapMultiScene;

    let x = mapMultiScene.cameraParams
        ? mapMultiScene.cameraParams.cameraPosition.x
        : null;
    let y = mapMultiScene.cameraParams
        ? mapMultiScene.cameraParams.cameraPosition.y
        : null;
    if (x && y) {
        sagasMap.getActions(dispatch).addCommand(
            'SET_CENTER', {x: x, y: y}
        );
    }
}

export default {
    name: 'mapmultiscene.setMapCenterByMultiScene',
    execute: setMapCenterByMultiScene
}
